/**
 * Shared formatting and parsing utilities for the frontend.
 * Use these everywhere to keep number/currency handling consistent.
 */

// Formats a number as a USD currency string (e.g. 1234.5 → "$1,234.50").
// Non-numeric input (e.g. an unresolved value) renders as "—" rather than "$NaN".
export function formatMoney(value) {
  const n = Number(value ?? 0);
  if (Number.isNaN(n)) return "—";
  return n.toLocaleString("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
}

// Strips any non-numeric characters from a user-typed string (e.g. "$", ",")
// and returns a number. Returns 0 for empty or invalid input so math never gets NaN.
// Used in forecast input fields across ForecastCalendar, DayForecastForm, and CreateForecastForm.
export function parseNumber(value) {
  const t = String(value).replace(/[^0-9.]/g, "");
  return t ? Number(t) : 0;
}
